export { default } from './DevicesTab';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/DevicesTab/index.ts